import React from "react";
import { useTranslation } from "react-i18next";

export default function TextStrokeColor(props) {
  const { t } = useTranslation();
  return (
    <li>
      <span
        className={`button normal-btn text-and-stroke-color ${
          props.activeButton === "textstroke" ? "active" : ""
        }`}
        title={t("Text and stroke color")}
        onClick={props.onClick}
        data-tip={t("Text and stroke color")}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            className="tas-color"
            x="1"
            y="1"
            width="14"
            height="14"
            fill={props.color}
            stroke="white"
            strokeWidth="2"
          />
          <path
            d="M12.25 5.5V5.25H12C11.3888 5.25 10.7346 5.40052 10.209 5.75096C9.66144 6.11599 9.25 6.70873 9.25 7.5C9.25 8.1792 9.56903 8.81606 9.79613 9.26939C9.7993 9.27573 9.80246 9.28204 9.80561 9.28831L10.0291 9.17637L9.80561 9.28831L9.82918 9.33541C10.1016 9.88034 10.25 10.212 10.25 10.5C10.25 10.7098 10.1604 10.8667 9.95897 11.001C9.73455 11.1506 9.38866 11.25 9 11.25H8.75V11.5V12.5V12.75H9C9.6112 12.75 10.2654 12.5995 10.791 12.249C11.3386 11.884 11.75 11.2913 11.75 10.5C11.75 9.8208 11.431 9.18394 11.2039 8.73061C11.2007 8.72427 11.1975 8.71796 11.1944 8.71169L11.1708 8.66459C10.8984 8.11966 10.75 7.78805 10.75 7.5C10.75 7.29019 10.8396 7.13333 11.041 6.99904C11.2655 6.84942 11.6113 6.75 12 6.75H12.25V6.5V5.5Z"
            fill="white"
            stroke="#A2A4A8"
            strokeWidth="0.5"
          />
          <rect x="0.5" y="0.5" width="15" height="15" stroke="#A2A4A8" />
        </svg>
      </span>
    </li>
  );
}
